import React from 'react';
import { useTranslation } from 'react-i18next';

import { Table } from 'components/Table';
import { useSelector } from 'store';

import useColumns from './hooks/useColumns';

import './AuctionVolumes.scss';

export interface AuctionVolumesProps {}

// eslint-disable-next-line @typescript-eslint/naming-convention
const INITIAL_TABLE_STATE = {
  sorting: [
    {
      id: 'element_number',
      desc: false,
    },
  ],
};

const AuctionVolumes = ({}: AuctionVolumesProps) => {
  const { t } = useTranslation();
  const elements = useSelector((store) => store.rfp.data.traro_element_list);
  const columns = useColumns();

  return (
    <section className="enkrateia-auction-volumes">
      <h2>{t('pages.prosforaProject.volumes.title')}</h2>
      <Table columns={columns} data={elements} initialState={INITIAL_TABLE_STATE} />
    </section>
  );
};

export default AuctionVolumes;
